/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-placeholder-card',
  templateUrl: './empty-placeholder-card.component.html',
  styleUrls: ['./empty-placeholder-card.component.scss']
})
export class EmptyPlaceholderCardComponent {
  @Input() title: string;

  @Input() icon: string;
}
